var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.hidden)?_c('span',{staticClass:"tooltiptext",class:{ hidden: _vm.hidden },on:{"mouseover":_vm.hide}},[_vm._v(_vm._s(_vm.text)+"\n")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }